module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-7.d056446e.jpg";